import React, { FC } from 'react';
import { ContainerLarge } from '../../components/base/grid';
import LandingPages, { LandingPageParameters } from '../../components/myPost/landingPages/landingPages';
import { getQueryParam } from '../../helpers/url/urlHelpers';
import pageWrapper from '../../hoc/pageWrapper';
import IPageViewModel from '../../interfaces/umbracoNodes/pageViewModel';

interface Props {
	page: IPageViewModel;
}

const MyShipmentsLandingPagesResetPassword: FC<Props> = ({ page }) => {
	const token = getQueryParam('token');
	const verificationid = getQueryParam('id');
	const params: LandingPageParameters = {
		token,
		verificationid,
	};
	return (
		<ContainerLarge>
			<LandingPages page={page} parameters={params} landingPage={'RESET_PASSWORD'} />
		</ContainerLarge>
	);
};

export default pageWrapper(MyShipmentsLandingPagesResetPassword);
